import script from "./RadioInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./RadioInput.vue?vue&type=script&setup=true&lang=ts"

import "./RadioInput.vue?vue&type=style&index=0&id=285781b2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-285781b2"]])

export default __exports__